import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Material UI Styles

import { AppContext } from '../../App';
import { img } from '../Utils';

import { Box, Button, IconButton, Popover, Typography, darken, lighten } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DialogOkCancel from '../DialogOkCancel';
import useApi from '../../api';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../api/cuenta';
import LoadingDialog from '../LoadingDialog';

const formatNombre = (record) => record.nombreCompleto;

const CuentaPopover = ({ ...props }) => {
    const { anchorEl } = props;
    const { cuenta, wipeAllData } = useContext(AppContext);
    const navigate = useNavigate();

    const [confirmDialog, setConfirmDialog] = useState({ open: false, msg: null });
    const [{ data: logoutData, loading: loadingLogout }, apiLogout] = useApi();

    const avatarImg = cuenta.avatar || img('/images/foto-perfil-empty.png');

    useEffect(() => {
        if (logoutData !== undefined) {
            wipeAllData();
            navigate("/", { replace: true });

        }
    }, [logoutData]);

    const handleClose = () => {
        props.onClose();
    };

    const handleEntered = () => {

    }

    const handleEnter = () => {

    }

    const handleCerrarSesion = () => {
        props.onClose();
        setConfirmDialog({
            open: true,
            msg: '¿Confirmas cerrar tu sesión?',
            onOk: callLogout,
            onCancel: () => setConfirmDialog({ open: false, msg: null })
        });

        if (props.onCerrarSesion) {
            props.onCerrarSesion();
        }

    }

    const handleAdminCuenta = (event) => {
        // event.preventDefault();
        if (props.onAdministrarCuenta) {
            props.onAdministrarCuenta();
        }
    }

    const callLogout = () => {
        setConfirmDialog({ open: false, msg: null });
        apiLogout(logout());
    }

    return (
        <>
            <Popover
                sx={{
                    overflowX: "unset",
                    overflowY: "unset",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        marginRight: "-0.71em",
                        top: 0,
                        right: 15,
                        width: 10,
                        height: 10,
                        backgroundColor: (theme) => theme.palette.type === 'light' ? lighten(theme.palette.primary.main, 0.5) : darken(theme.palette.primary.main, 0.5),
                        // backgroundColor: theme.palette.background.paper,
                        boxShadow: (theme) => theme.shadows[1],
                        transform: "translate(-50%, -50%) rotate(315deg)",
                        clipPath: "polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))",
                    },
                }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                TransitionProps={{
                    onEnter: handleEnter,
                    onEntered: handleEntered
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>
                <Box sx={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{
                        display: 'flex',
                        backgroundColor: (theme) => theme.palette.type === 'light' ? lighten(theme.palette.primary.main, 0.5) : darken(theme.palette.primary.main, 0.5),
                        height: 56,
                        alignItems: 'center',
                        paddingRight: 1
                    }}>
                        <div style={{ flexGrow: 1, alignSelf: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row', padding: 16 }}>
                            <Typography variant="body1" color="primary" component="div" style={{ flexGrow: 1, fontWeight: 450, color: 'white' }}>Cuenta</Typography>
                        </div>
                        <IconButton style={{ marginLeft: 16 }} onClick={() => handleClose()} >
                            <CloseIcon style={{ color: 'white' }} />
                        </IconButton>
                    </Box>
                    <Box sx={{
                        borderBottom: '1px solid #ccc',
                        padding: 1,
                        display: 'flex',
                        backgroundColor: (theme) => theme.palette.type === 'light' ? lighten(theme.palette.primary.main, 0.5) : darken(theme.palette.primary.main, 0.5),
                    }}>
                        <div style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
                            <Box sx={{
                                padding: 1,
                                display: 'flex',
                                cursor: 'pointer',
                            }}>
                                <Box sx={{
                                    backgroundSize: '80px 80px',
                                    border: 'none',
                                    height: 80,
                                    width: 80,
                                    borderRadius: '50%',
                                    content: `url(${avatarImg})`
                                }} />
                                {/* <Typography variant="caption" align="center" style={{ position: 'absolute', padding: '4px 0px', bottom: 0, width: 96, color: '#fff', backgroundColor: 'rgba(0,0,0,.54)' }}>Cambiar</Typography> */}
                            </Box>
                        </div>
                        <div>
                            <Typography variant="subtitle2" style={{ color: 'white' }} gutterBottom>{formatNombre(cuenta)}</Typography>
                            <Typography variant="body2" style={{ marginBottom: 16, color: 'white' }}>{cuenta.email}</Typography>
                            <Button color="primary" variant="contained" onClick={handleAdminCuenta}>Administrar cuenta</Button>
                        </div>
                    </Box>
                    <Button sx={{ padding: 1, }} endIcon={<ExitToAppIcon />} color="primary" onClick={handleCerrarSesion}>Cerrar sesión</Button>
                </Box>
            </Popover>
            <LoadingDialog open={loadingLogout} />
            <DialogOkCancel {...confirmDialog} />
        </>
    )
}

CuentaPopover.propTypes = {
    anchorEl: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onAdministrarCuenta: PropTypes.func,
    onCerrarSesion: PropTypes.func,
    onCambiarColegio: PropTypes.func,
};

CuentaPopover.displayName = 'CuentaPopover';

export default CuentaPopover;